import { routerNavigatedAction } from '@ngrx/router-store';
import { on } from '@ngrx/store';

import { JobCreateLocationsActions } from 'src/app/job/job-create/job-create-locations/job-create-locations-state.actions';
import { JobCreateActions } from 'src/app/job/job-create/job-create-state/job-create.actions';
import { ControlMetaActions } from 'src/app/new-opportunity/control-meta.directive';
import { LoadingState } from 'src/app/utilities/state.util';

import { NewOpportunityLocationsActions } from './new-opportunity-locations/new-opportunity-locations.actions';
import { NewOpportunityActions } from './new-opportunity.actions';
import { NEW_OPPORTUNITY_STEPS, NewOpportunityState, NewOpportunityStep, newOpportunityInitialState } from './new-opportunity.state';

export const newOpportunityReducers = [
    on(NewOpportunityActions.validateStepChangeSuccess, (state: NewOpportunityState, { step }): NewOpportunityState => ({
        ...state,
        step,
    })),
    on(routerNavigatedAction, (state: NewOpportunityState, { payload: { routerState } }): NewOpportunityState => {

        const stepParam = routerState.root.queryParams['step'] as NewOpportunityStep;

        if (!NEW_OPPORTUNITY_STEPS.includes(stepParam)) {
            return state;
        }

        return {
            ...state,
            step: stepParam,
        };
    }),
    on(JobCreateActions.newOpportunityButtonClicked, (state: NewOpportunityState): NewOpportunityState => ({
        ...state,
        step: 'customer',
    })),
    on(ControlMetaActions.controlMetaUpdated, (state: NewOpportunityState, { field, meta }): NewOpportunityState => ({
        ...state,
        controlMeta: {
            ...state.controlMeta,
            [field]: meta,
        },
    })),
    on(NewOpportunityActions.buildCreateJobVariablesError, (state: NewOpportunityState, { error }): NewOpportunityState => ({
        ...state,
        createJobCall: { error },
    })),
    on(NewOpportunityActions.buildCreateJobVariablesSuccess, (state: NewOpportunityState): NewOpportunityState => ({
        ...state,
        createJobCall: LoadingState.MUTATING,
    })),
    on(NewOpportunityActions.createJobSuccess, (state: NewOpportunityState): NewOpportunityState => ({
        ...state,
        createJobCall: LoadingState.MUTATED,
    })),
    on(NewOpportunityActions.createJobError, (state: NewOpportunityState, { error }): NewOpportunityState => ({
        ...state,
        createJobCall: { error },
    })),
    on(NewOpportunityActions.createJobWithMissingLocationDataConfirmed, (state: NewOpportunityState): NewOpportunityState => ({
        ...state,
        createJobWithMissingLocationDataConfirmed: true,
        step: 'inventory',
    })),
    on(ControlMetaActions.controlMetaCleared, (state: NewOpportunityState, { field }): NewOpportunityState => {
        if (!(field in state.controlMeta)) {
            return state;
        }

        const { [field]: _removedControlMeta, ...controlMeta } = state.controlMeta;

        return {
            ...state,
            controlMeta,
        };
    }),
    on(
        NewOpportunityLocationsActions.googleAutocompleteAddressSelected,
        NewOpportunityLocationsActions.exitMinimalViewButtonClicked,
        NewOpportunityLocationsActions.addLocationManuallyButtonClicked,
        (state: NewOpportunityState): NewOpportunityState => ({
            ...state,
            locationsStepMinimalView: false,
        }),
    ),
    on(JobCreateLocationsActions.jobLocationsLoaded, (state: NewOpportunityState, { job }): NewOpportunityState => {
        if (!job?.locations?.length) {
            return state;
        }
        return {
            ...state,
            locationsStepMinimalView: false,
        };
    }),
    on(routerNavigatedAction, (state: NewOpportunityState, { payload: { event: { urlAfterRedirects } } }): NewOpportunityState => {
      if (urlAfterRedirects.startsWith('/jobs/new')) {
        return newOpportunityInitialState;
      }
      return state;
    }),
];
